import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/breadcrumb/DashboardBreadcrumb.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/cards/HrmDashboardCards.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/charts/AudienceChart.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/component/employee/Attendance.tsx")